import { config } from 'api';
import fetchAction from 'utils/fetchAction';

const url = `${config.apiBasePath}/delivery-slot/next`;

export const FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_REQUEST = 'FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_REQUEST';
export const FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_SUCCESS = 'FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_SUCCESS';
export const FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_ERROR = 'FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_ERROR';

export const fetchNextAvailableDeliverySlot = fetchAction({
  actions: [
    FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_REQUEST,
    FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_SUCCESS,
    FETCH_NEXT_AVAILABLE_DELIVERY_SLOT_ERROR,
  ],
  url,
});
